import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { ApplicationRef, Injector, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { SchedulerModule } from 'angular-calendar-scheduler';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { QuillModule } from 'ngx-quill';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { SharedModule } from './shared/modules/shared.module';
import { CustomMatPaginatorIntl } from './shared/controls/custom-mat-paginator-intl/custom.mat.paginator.intl';

import { HomeModule } from './home/home.module';
import { AccountModule } from './account/account.module';
import { AdminModule } from './admin/admin.module';
import { CustomerModule } from './customer/customer.module';
import { DealerModule } from './dealer/dealer.module';
import { LeadModule } from './lead/lead.module';
import { QuoteModule } from './quote/quote.module';
import { JobModule } from './job/job.module';
import { WorkOrderModule } from './work-order/work.order.module';
import { ReportsModule } from './reports/reports.module';
import { ResourceCalendarModule } from './calendar/resource.calendar.module';
import { SupportModule } from './support/support.module';
import { UserModule } from './user/user.module';

import { JwtInterceptor } from './shared/modules/jwt.interceptor';
import { LoginService } from './login/services/login.service';
import { RootComponent } from './root/root.component';
import { LoginModule } from './login/login.module';
import { ExportsModule } from './exports/exports.module';
import { MenuBarComponent } from './menu-bar/menu-bar.component';
import { ContactModule } from './contact/contact.module';
import { ServiceLocator, services } from './shared/services/service.locator';
import { MediaMatcher } from '@angular/cdk/layout';
import { WeblinkModule } from './weblink/weblink.module';
import { MatButtonModule } from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import { ReleaseModule } from './release/release.module';

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    MenuBarComponent,
    RootComponent,
    HomeComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    FormsModule, ReactiveFormsModule, LoginModule,
    HomeModule, AccountModule, AdminModule, DealerModule, CustomerModule, ExportsModule,
    LeadModule, QuoteModule, JobModule, ReportsModule, ResourceCalendarModule,
    ReleaseModule, SupportModule, UserModule, WeblinkModule, WorkOrderModule,
    ContactModule,
    HttpClientModule,
    MatAutocompleteModule, MatCheckboxModule, MatDatepickerModule, MatDialogModule, MatNativeDateModule,
    MatPaginatorModule, MatRadioModule, MatSelectModule, MatSortModule, MatTabsModule, MatTableModule, MatTooltipModule, MatCardModule,
    MatSnackBarModule,
    MatButtonModule, MatIconModule,
    InfiniteScrollModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    SchedulerModule.forRoot({
      locale: 'en',
      headerDateFormat: 'daysRange'
    }),
    SharedModule,
    QuillModule.forRoot({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{ 'indent': '-1' }, { 'indent': '+1' }],
          [{ 'size': ['small', false, 'large', 'huge'] }],
        ]
      },
    }),
    RouterModule.forRoot([
    {
        path: '', component: RootComponent,
        children: [
            {
                path: '', component: HomeComponent,
            },
        ]
    },
], {}),
    BrowserAnimationsModule
  ],
  exports: [
    MatAutocompleteModule, MatCheckboxModule, MatDatepickerModule, MatDialogModule,
    MatRadioModule, MatSelectModule, MatTabsModule, MatTooltipModule, MatCardModule,
    MatButtonModule, MatIconModule,
  ],
  providers: [
    MatNativeDateModule,
    LoginService,
    DatePipe,
    { provide: MatPaginatorIntl, useValue: CustomMatPaginatorIntl() },
    { provide: 'googleTagManagerId', useValue: 'GTM-NF5MH6K'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
